import { ActionEvent, ActionEventData } from '../action/action-event'
import { DownloadContentDisposition } from './download-options'

/**
 * @public
 */
export interface DownloadEventData extends ActionEventData {
  disposition?: DownloadContentDisposition
}

/**
 * @public
 */
export interface DownloadCompletedEventData extends DownloadEventData {
  file: File
}

/**
 * Data containing the error that was encountered while trying to download the file.
 *
 * @public
 */
export interface DownloadFailedEventData extends DownloadEventData {
  error: Error
}

/**
 * @public
 */
export interface DownloadEventInit extends EventInit, DownloadEventData { }

/**
 * @public
 */
export interface DownloadCompletedEventInit extends EventInit, DownloadCompletedEventData { }

/**
 * @public
 */
export interface DownloadFailedEventInit extends EventInit, DownloadFailedEventData { }

/**
 * @public
 */
export class DownloadEvent extends ActionEvent {

  /**
   * The way the downloaded file will be presented upon download completion.
   */
  disposition?: DownloadContentDisposition

  constructor(type: string, eventInitDict: DownloadEventInit | DownloadCompletedEventInit | DownloadFailedEventInit) {
    super(type, eventInitDict)
    this.disposition = eventInitDict?.disposition
  }

}
